/* DEV-290 (2026-09-26): product page additions, loaded from snippets/lm-pdp.liquid. See that snippet for the why.
   v6 (Developer C): click-to-zoom for carousel galleries shown as a desktop grid.
   v6 exact (Developeris E, 2026-09-26): the product page is laid out as the v6 artifact screen "Prekė: STORY" (see
   snippets/lm-pdp.liquid for the CSS): model name + subtitle, stars in the price row, "N colours", size-help link text,
   "Add to cart · price", one trust box, studio link under it, accordions under the product, two shelves, the category
   feed above the footer, back button over the photo and the sticky bar "name / price · size / Add to cart".
   Only text and placement change here; variant, cart and D15 logic stay with the blocks that own them. */
const config = (() => {
  try { return JSON.parse(document.querySelector('[data-lm-pdp-config]').textContent); } catch (error) { return null; }
})();
const main = document.querySelector('.shopify-section--main-product');

/* 1/N counter over the photo on phones, following the swipe and the colour filter */
const counter = () => {
  const list = main && main.querySelector('.product-gallery__media-list');
  /* the live theme may already print its own counter (e.g. from another card); then this one is not added */
  if (!list || main.querySelector('.lm-gcount')) return;
  const badge = document.createElement('span');
  badge.className = 'lm-gcount';
  badge.setAttribute('aria-hidden', 'true');
  list.parentElement.append(badge);
  const update = () => {
    const items = [...list.children].filter((item) => item.classList.contains('product-gallery__media') && item.getClientRects().length);
    if (items.length < 2) { badge.hidden = true; return; }
    const left = list.getBoundingClientRect().left;
    let index = items.findIndex((item) => item.getBoundingClientRect().right - left > item.offsetWidth / 2);
    if (index < 0) index = 0;
    badge.hidden = false;
    badge.textContent = (index + 1) + ' / ' + items.length;
  };
  /* another counter printed later by the theme (see above) wins: this one is removed */
  const rival = new MutationObserver(() => {
    if ([...main.querySelectorAll('.lm-gcount')].some((node) => node !== badge)) { badge.remove(); rival.disconnect(); }
  });
  rival.observe(main, { childList: true, subtree: true });
  setTimeout(() => rival.disconnect(), 10000);
  let frame = 0;
  list.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, { passive: true });
  new MutationObserver(update).observe(list, { subtree: true, attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
  update();
};

/* the size chosen in a collection filter (DEV-288, sessionStorage lm-size) is preselected when it is in stock */
const presetSize = () => {
  let sizes = [];
  try { sizes = JSON.parse(sessionStorage.getItem('lm-size') || '[]'); } catch (error) {}
  const picker = main && main.querySelector('variant-picker[data-size-position]');
  /* UI-1012-16: a confirmed product choice outranks the collection's default size. */
  if (new URL(location.href).searchParams.get('option_values') ||
      (picker && (window.__lemuseExplicitSizeChoices || {})[picker.getAttribute('handle')])) return;
  if (!Array.isArray(sizes) || !sizes.length || !picker) return;
  const position = picker.getAttribute('data-size-position');
  const inputs = [...picker.querySelectorAll(`input[data-option-position="${position}"]`)];
  if (inputs.some((input) => input.checked && input.hasAttribute('data-lm-picked'))) return;
  const wanted = sizes.map((size) => String(size).trim().toLowerCase());
  const input = inputs.find((candidate) => {
    const label = picker.querySelector(`label[for="${CSS.escape(candidate.id)}"]`);
    const text = (label ? label.textContent : candidate.value).trim().toLowerCase();
    return wanted.includes(text) && candidate.dataset.available !== 'false' && !candidate.disabled;
  });
  if (!input || input.checked) return;
  const label = picker.querySelector(`label[for="${CSS.escape(input.id)}"]`);
  input.setAttribute('data-lm-picked', '');
  (label || input).click();
};

/* featured products (tag "featured", DEV-293) take places 1, 5, 9 in the similar-product lists under the product; the
   other cards keep the ATC order the server gave them (Developeris B, 2026-09-30, Audrius: ATC order everywhere) */
const featuredSlots = (cards) => {
  const top = cards.filter((card) => card.hasAttribute('data-lm-featured'));
  const rest = cards.filter((card) => !card.hasAttribute('data-lm-featured'));
  const out = [];
  while (top.length || rest.length) out.push((out.length % 4 === 0 && top.length) || !rest.length ? top.shift() : rest.shift());
  return out;
};
const featuredFirst = (root) => {
  root.querySelectorAll('product-card[data-lm-featured]').forEach((card) => {
    const parent = card.parentElement;
    if (!parent || parent.closest('.lm-more') || parent.dataset.lmFeaturedDone) return;
    parent.dataset.lmFeaturedDone = 'true';
    const cards = [...parent.children].filter((child) => child.tagName === 'PRODUCT-CARD');
    const ordered = featuredSlots(cards);
    if (ordered.every((child, index) => child === cards[index])) return;
    const after = cards[cards.length - 1].nextSibling;
    ordered.forEach((child) => parent.insertBefore(child, after));
  });
};

/* the same category keeps loading under the product, 12 at a time */
const moreFromCategory = () => {
  const crumbs = [...document.querySelectorAll('main [id$="__d9_breadcrumbs"] a[href*="/collections/"]')];
  const crumb = crumbs[crumbs.length - 1];
  const link = config && config.cat ? { href: config.cat.url, textContent: config.cat.title } : crumb;
  if (!link || !config) return;
  const collectionUrl = new URL(link.href, location.href);
  /* v6: the footer group sits inside <main> in this layout; the feed goes above it, not under the footer */
  const sections = [...document.querySelectorAll('main > .shopify-section:not(.shopify-section-group-footer-group)')];
  const last = sections[sections.length - 1];
  if (!last) return;
  const box = document.createElement('section');
  box.className = 'lm-more';
  box.innerHTML = '<h2></h2><div class="lm-more__grid"></div><a class="lm-more__all"></a>';
  box.querySelector('h2').textContent = config.more.replace('%C', link.textContent.trim());
  const all = box.querySelector('.lm-more__all');
  all.href = collectionUrl.pathname;
  all.textContent = config.all;
  const grid = box.querySelector('.lm-more__grid');
  last.after(box);
  const seen = new Set([config.handle]);
  /* DEV-532 (2026-09-29, Developeris F): the feed repeated every product already shown in "Similar styles" and "Pair it with"
     (7 of 7 on SUMMER KISS, 8 of 8 on STORY). Products already on the page are skipped, and a shelf that renders after the
     feed has loaded takes its products back out of the feed. */
  const shown = () => new Set([...document.querySelectorAll('main product-card[handle]')]
    .filter((card) => !box.contains(card)).map((card) => card.getAttribute('handle')));
  const prune = () => {
    const onPage = shown();
    grid.querySelectorAll('product-card[handle]').forEach((card) => { if (onPage.has(card.getAttribute('handle'))) card.remove(); });
  };
  if (window.MutationObserver) {
    let pruneFrame = 0;
    const watch = new MutationObserver(() => { cancelAnimationFrame(pruneFrame); pruneFrame = requestAnimationFrame(prune); });
    watch.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    setTimeout(() => watch.disconnect(), 20000);
  }
  let page = 0;
  let pages = 1;
  let loading = false;
  let cardScript = false;
  /* T1 (2026-09-26): a busy store answers 429; one retry after a short wait, as the header Retry-After asks (at most 5 s) */
  const get = async (url) => {
    let response = await fetch(url, { credentials: 'same-origin' }).catch(() => null);
    if (response && response.ok) return response;
    const wait = response ? Math.min(5, Number(response.headers.get('Retry-After')) || 1.5) : 1.5;
    await new Promise((resolve) => setTimeout(resolve, wait * 1000));
    response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error(response.status);
    return response;
  };
  /* Developeris B (2026-09-30, Audrius: "visos prekes visur ... rusiuojamos pagal ATC rate"): when the category has
     cro.atc_order, its pages are read once and the feed follows the whole list (the same order lm-atc-ranker gives the
     collection page): ATC order, featured in places 1, 5, 9, the sponsored product left out. Without the list the feed
     takes the collection's pages as before. */
  let ranked = null;
  const rankAll = async (first) => {
    let ranking = null;
    try { ranking = JSON.parse(first.querySelector('lm-atc-ranker [data-atc-ranking]').textContent); } catch (error) { return null; }
    if (!ranking || !Array.isArray(ranking.ids) || !ranking.ids.length) return null;
    const docs = [first];
    for (let n = 2; n <= Math.min(pages, 20); n += 1) {
      const url = new URL(collectionUrl);
      url.searchParams.set('page', n);
      docs.push(new DOMParser().parseFromString(await (await get(url.toString())).text(), 'text/html'));
    }
    const byId = new Map();
    const cards = new Map();
    const sponsored = new Set();
    docs.forEach((doc) => {
      let slots = [];
      let ids = [];
      try { slots = JSON.parse(doc.querySelector('[data-atc-slots]').textContent); ids = JSON.parse(doc.querySelector('[data-atc-slot-ids]').textContent); } catch (error) {}
      ids.forEach((id, i) => byId.set(String(id), slots[i]));
      doc.querySelectorAll('[data-lm-sponsored]').forEach((node) => sponsored.add(node.getAttribute('data-lm-sponsored')));
      const found = [...doc.querySelectorAll('product-list.product-list > product-card[handle]:not([data-lm-sponsored])')];
      doc.querySelectorAll('template[data-lm-extra]').forEach((tpl) => found.push(...tpl.content.querySelectorAll('product-card[handle]')));
      found.forEach((card) => { if (!cards.has(card.getAttribute('handle'))) cards.set(card.getAttribute('handle'), card); });
    });
    const order = [...new Set(ranking.ids.map((gid) => byId.get(String(gid).split('/').pop())).filter((handle) => handle && cards.has(handle) && !sponsored.has(handle)))];
    cards.forEach((card, handle) => { if (!sponsored.has(handle) && !order.includes(handle)) order.push(handle); });
    return featuredSlots(order.map((handle) => cards.get(handle)));
  };
  const put = (cards) => {
    const onPage = shown();
    cards.forEach((card) => {
      const handle = card.getAttribute('handle');
      if (!handle || seen.has(handle) || onPage.has(handle) || grid.children.length >= 48) return;
      seen.add(handle);
      const clone = document.importNode(card, true);
      clone.removeAttribute('reveal-js');
      grid.append(clone);
    });
  };
  const load = async () => {
    if (loading || grid.children.length >= 48) return;
    if (ranked) {
      put(ranked.splice(0, 12));
      if (!ranked.length) pages = page;
      check();
      return;
    }
    if (page >= pages) return;
    loading = true;
    try {
      const url = new URL(collectionUrl);
      url.searchParams.set('page', page + 1);
      const response = await get(url.toString());
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      page += 1;
      const feed = doc.querySelector('[data-lm-feed]');
      try { pages = feed ? JSON.parse(feed.textContent).pages : page; } catch (error) { pages = page; }
      if (page === 1) {
        ranked = await rankAll(doc).catch(() => null);
        if (ranked) {
          pages = page + 1;
          put(ranked.splice(0, 12));
          if (!cardScript && config.card) { cardScript = true; import(config.card).catch(() => {}); }
          return;
        }
      }
      const onPage = shown();
      doc.querySelectorAll('product-list.product-list > product-card').forEach((card) => {
        const handle = card.getAttribute('handle');
        if (!handle || seen.has(handle) || onPage.has(handle)) return;
        seen.add(handle);
        const clone = document.importNode(card, true);
        clone.removeAttribute('reveal-js');
        grid.append(clone);
      });
      if (!cardScript && config.card) { cardScript = true; import(config.card).catch(() => {}); }
    } catch (error) {
      pages = 0;
      /* no cards at all: the empty heading is not left on the page */
      if (!grid.children.length) box.remove();
    } finally {
      loading = false;
    }
    check();
  };
  let frame = 0;
  const check = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      if ((page >= pages && !(ranked && ranked.length)) || grid.children.length >= 48) { window.removeEventListener('scroll', check); return; }
      if (box.getBoundingClientRect().bottom < window.innerHeight + 900) load();
    });
  };
  window.addEventListener('scroll', check, { passive: true });
  check();
};

/* ♡ next to "Add to cart"; lm-card.js keeps the saved list and handles the tap */
const HEART = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M12 20.5s-7.5-4.6-9.2-9.3C1.6 7.8 3.8 4.5 7.2 4.5c2 0 3.6 1.1 4.8 2.8 1.2-1.7 2.8-2.8 4.8-2.8 3.4 0 5.6 3.3 4.4 6.7-1.7 4.7-9.2 9.3-9.2 9.3z"/></svg>';
const heart = () => {
  const buttons = main.querySelector('[data-block-type="buy-buttons"] buy-buttons');
  if (!buttons || !config || buttons.querySelector('.lm-pdp-heart')) return;
  let saved = [];
  try { saved = JSON.parse(localStorage.getItem('lm-atranka')) || []; } catch (error) {}
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'lm-pdp-heart';
  button.dataset.lmHeart = config.handle;
  button.setAttribute('aria-pressed', Array.isArray(saved) && saved.includes(config.handle) ? 'true' : 'false');
  button.setAttribute('aria-label', config.save || '♡');
  button.innerHTML = HEART;
  buttons.append(button);
  if (config.card) import(config.card).catch(() => {});
};

/* the first-visit country bar waits while the photos or "Add to cart" are on screen, so it covers neither */
const geoBar = () => {
  const bar = document.getElementById('d13-geo');
  const watched = [main.querySelector('.product-gallery'), main.querySelector('[data-block-type="buy-buttons"]')].filter(Boolean);
  if (!bar || !watched.length || !('IntersectionObserver' in window)) return;
  const onScreen = new Set();
  const apply = () => bar.classList.toggle('lm-geo-wait', onScreen.size > 0);
  bar.classList.add('lm-geo-wait');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => { if (entry.isIntersecting) onScreen.add(entry.target); else onScreen.delete(entry.target); });
    apply();
  });
  watched.forEach((el) => observer.observe(el));
};

/* DEV-296: "create your own version" link to the studio, under "Add to cart" */
const studioLink = () => {
  const info = main.querySelector('.product-info');
  if (!info || !config || !config.studio || info.querySelector('.lm-pdp-studio')) return;
  const link = document.createElement('a');
  link.className = 'lm-pdp-studio';
  link.href = config.studio.url;
  link.textContent = config.studio.text;
  /* v6: a direct child of the details column, under the trust box (CSS order) */
  info.append(link);
};

/* desktop: carousel galleries are shown as a 2-column grid (snippet CSS); a click on a photo opens the theme's zoom
   instead of turning the carousel.
   DEV-445 (2026-09-28): on touch screens the theme opened the zoom only on a two-finger pinch (dots and the zoom button
   are hidden on phones by the snippet CSS), so a tap on the photo did nothing. A tap now opens the same zoom; a swipe
   still turns the carousel, because a swipe gives no click. In the zoom the prev/next arrows grow to 44 px and the bottom
   bar keeps clear of the phone's home bar. */
const gridZoom = () => {
  const carousel = main.querySelector('.product-gallery--desktop-carousel media-carousel');
  if (!carousel) return;
  const desktop = window.matchMedia('(min-width: 1000px), (pointer: coarse)');
  if (!document.getElementById('lm-pswp-css')) {
    const css = document.createElement('style');
    css.id = 'lm-pswp-css';
    css.textContent = '.pswp .pagination__item{width:44px;height:44px}.pswp .pswp__bottom-bar{padding-bottom:env(safe-area-inset-bottom,0px)}';
    document.head.append(css);
  }
  carousel.addEventListener('click', (event) => {
    if (!desktop.matches || event.target.closest('button, a[href]')) return;
    const media = event.target.closest('.product-gallery__media[data-media-type="image"]');
    if (!media) return;
    const images = [...carousel.children].filter((item) => item.classList.contains('product-gallery__media') && !item.hidden && item.getAttribute('data-media-type') === 'image');
    const index = images.indexOf(media);
    if (index < 0) return;
    event.stopImmediatePropagation();
    media.dispatchEvent(new CustomEvent('lightbox:open', { bubbles: true, detail: { index } }));
  }, true);
};


/* ---------- v6 exact ---------- */
const T = {
  lt: { ship: 'Pristatymas per 2–5 d. d.', ddp: 'ES – be muitų, kainos su PVM', ddpWorld: 'Importo muitai ir mokesčiai įskaičiuoti: juos sumokame mes, pristatant nieko papildomai mokėti nereikia', pick: 'pasirink', both: 'Pridėti abi', soText: 'Rinkis to paties modelio 2 spalvas – pigesnei −25 %. Nuolaida pritaikoma automatiškai.', atc: 'Į krepšelį', sizeq: 'dydis?', help: 'Kaip pasirinkti dydį?', desc: 'Aprašymas', chart: 'Dydžių lentelė', reviews: 'Atsiliepimai', similar: 'Panašūs modeliai', pair: 'Derinkite su', all: 'Visos %N →', allCard: 'Žiūrėti visas %N →', free: 'nemokamas', freeFrom: 'nemokamas nuo %T (liko %R)', returns: 'Grąžinimas pagal grąžinimo politiką', back: 'Atgal', colours: (n) => n + ' ' + (n % 10 === 1 && n % 100 !== 11 ? 'spalva' : (n % 10 === 0 || (n % 100 > 10 && n % 100 < 20)) ? 'spalvų' : 'spalvos') },
  de: { ship: 'Lieferung in 2–5 Werktagen', ddp: 'Keine Zollgebühren in der EU; Preise inkl. MwSt.', ddpWorld: 'Einfuhrzölle und Steuern inklusive: Wir übernehmen sie, bei der Lieferung zahlen Sie nichts extra', pick: 'bitte wählen', both: 'Beide hinzufügen', soText: 'Wählen Sie 2 Farben desselben Modells – die günstigere ist 25 % reduziert. Der Rabatt wird automatisch abgezogen.', atc: 'In den Warenkorb', sizeq: 'Größe?', help: 'Welche Größe passt?', desc: 'Beschreibung', chart: 'Größentabelle', reviews: 'Bewertungen', similar: 'Ähnliche Modelle', pair: 'Kombinieren Sie mit', all: 'Alle %N →', allCard: 'Alle %N ansehen →', free: 'kostenlos', freeFrom: 'kostenlos ab %T (noch %R)', returns: 'Rückgabe gemäß Rückgaberichtlinie', back: 'Zurück', colours: (n) => n + (n === 1 ? ' Farbe' : ' Farben') },
  da: { ship: 'Levering på 2–5 hverdage', ddp: 'Ingen toldgebyrer i EU; priserne er inkl. moms', ddpWorld: 'Importafgifter og skatter inkluderet: vi betaler dem, intet ekstra at betale ved levering', pick: 'vælg', both: 'Tilføj begge', soText: 'Vælg 2 farver af samme model – den billigste får −25 %. Rabatten trækkes automatisk.', atc: 'Læg i kurv', sizeq: 'størrelse?', help: 'Hvordan vælger jeg størrelse?', desc: 'Beskrivelse', chart: 'Størrelsesguide', reviews: 'Anmeldelser', similar: 'Lignende modeller', pair: 'Kombinér med', all: 'Alle %N →', allCard: 'Se alle %N →', free: 'gratis', freeFrom: 'gratis fra %T (mangler %R)', returns: 'Returnering efter returpolitikken', back: 'Tilbage', colours: (n) => n + (n === 1 ? ' farve' : ' farver') },
  fi: { ship: 'Toimitus 2–5 arkipäivässä', ddp: 'Ei tullimaksuja EU:ssa; hinnat sisältävät ALV:n', ddpWorld: 'Tuontitullit ja -verot sisältyvät hintaan: me maksamme ne, toimituksen yhteydessä ei lisämaksuja', pick: 'valitse', both: 'Lisää molemmat', soText: 'Valitse saman mallin 2 väriä – edullisempi −25 %. Alennus vähennetään automaattisesti.', atc: 'Lisää ostoskoriin', sizeq: 'koko?', help: 'Miten valitsen koon?', desc: 'Kuvaus', chart: 'Kokotaulukko', reviews: 'Arvostelut', similar: 'Samankaltaiset mallit', pair: 'Yhdistä näiden kanssa', all: 'Kaikki %N →', allCard: 'Näytä kaikki %N →', free: 'ilmainen', freeFrom: 'ilmainen yli %T (puuttuu %R)', returns: 'Palautus palautuskäytännön mukaan', back: 'Takaisin', colours: (n) => n + (n === 1 ? ' väri' : ' väriä') },
  fr: { ship: 'Livraison sous 2 à 5 jours ouvrés', ddp: 'Pas de frais de douane dans l’UE ; prix TVA comprise', ddpWorld: 'Droits d’importation et taxes inclus : nous les prenons en charge, rien à payer à la livraison', pick: 'à choisir', both: 'Ajouter les deux', soText: 'Choisissez 2 couleurs du même modèle – la moins chère est à −25 %. La remise s’applique automatiquement.', atc: 'Ajouter au panier', sizeq: 'taille ?', help: 'Comment choisir sa taille ?', desc: 'Description', chart: 'Guide des tailles', reviews: 'Avis', similar: 'Modèles similaires', pair: 'À associer avec', all: 'Tous (%N) →', allCard: 'Voir les %N →', free: 'offerte', freeFrom: 'offerte dès %T (encore %R)', returns: 'Retours selon notre politique de retour', back: 'Retour', colours: (n) => n + (n === 1 ? ' couleur' : ' couleurs') },
  nl: { ship: 'Levering binnen 2–5 werkdagen', ddp: 'Geen douanekosten in de EU; prijzen incl. btw', ddpWorld: 'Invoerrechten en belastingen inbegrepen: wij betalen ze, bij levering betaal je niets extra', pick: 'kies', both: 'Beide toevoegen', soText: 'Kies 2 kleuren van hetzelfde model – de goedkoopste krijgt −25%. De korting wordt automatisch toegepast.', atc: 'In winkelwagen', sizeq: 'maat?', help: 'Welke maat kies ik?', desc: 'Beschrijving', chart: 'Maattabel', reviews: 'Beoordelingen', similar: 'Vergelijkbare modellen', pair: 'Combineer met', all: 'Alle %N →', allCard: 'Bekijk alle %N →', free: 'gratis', freeFrom: 'gratis vanaf %T (nog %R)', returns: 'Retourneren volgens ons retourbeleid', back: 'Terug', colours: (n) => n + (n === 1 ? ' kleur' : ' kleuren') },
  no: { ship: 'Levering på 2–5 virkedager', ddp: 'Ingen tollavgifter i EU; prisene inkluderer mva.', ddpWorld: 'Toll og importavgifter inkludert: vi betaler dem, ingenting ekstra å betale ved levering', pick: 'velg', both: 'Legg til begge', soText: 'Velg 2 farger av samme modell – den billigste får −25 %. Rabatten trekkes automatisk.', atc: 'Legg i handlekurv', sizeq: 'størrelse?', help: 'Hvordan velge størrelse?', desc: 'Beskrivelse', chart: 'Størrelsestabell', reviews: 'Anmeldelser', similar: 'Lignende modeller', pair: 'Kombiner med', all: 'Alle %N →', allCard: 'Se alle %N →', free: 'gratis', freeFrom: 'gratis fra %T (%R igjen)', returns: 'Retur etter returpolicyen', back: 'Tilbake', colours: (n) => n + (n === 1 ? ' farge' : ' farger') },
  sv: { ship: 'Leverans inom 2–5 arbetsdagar', ddp: 'Inga tullavgifter inom EU; priserna inkluderar moms', ddpWorld: 'Importtullar och skatter ingår: vi betalar dem, inget extra att betala vid leverans', pick: 'välj', both: 'Lägg till båda', soText: 'Välj 2 färger av samma modell – den billigare får −25 %. Rabatten dras automatiskt.', atc: 'Lägg i varukorgen', sizeq: 'storlek?', help: 'Hur väljer jag storlek?', desc: 'Beskrivning', chart: 'Storlekstabell', reviews: 'Omdömen', similar: 'Liknande modeller', pair: 'Kombinera med', all: 'Alla %N →', allCard: 'Visa alla %N →', free: 'gratis', freeFrom: 'gratis från %T (%R kvar)', returns: 'Retur enligt returpolicyn', back: 'Tillbaka', colours: (n) => n + (n === 1 ? ' färg' : ' färger') },
  en: { ship: 'Delivery in 2–5 business days', ddp: 'No customs fees in the EU; prices include VAT', ddpWorld: 'Import duties and taxes included: we pay them, nothing extra to pay on delivery', pick: 'choose', both: 'Add both', soText: 'Choose 2 colours of the same style – the cheaper one is 25% off. The discount is applied automatically.', atc: 'Add to cart', sizeq: 'size?', help: 'How to choose your size?', desc: 'Description', chart: 'Size chart', reviews: 'Reviews', similar: 'Similar styles', pair: 'Pair it with', all: 'All %N →', allCard: 'See all %N →', free: 'free', freeFrom: 'free over %T (%R to go)', returns: 'Returns under our returns policy', back: 'Back', colours: (n) => n + (n === 1 ? ' colour' : ' colours') }
};
const L = T[(config && config.lang) || 'en'] || T.en;
/* DEV-492 (2026-09-29): the free-shipping remainder counts the cart, not only this product. It is what is still missing
   once this variant is in the cart: threshold − cart total − this variant's price (its price is not added again when the
   variant is already in the cart). With the cart already at the threshold the line says free delivery applies. The cart
   is re-read after every cart change, so the line follows Add to cart without a reload. Shop currency only, as before. */
const FREE_YOU = {
  lt: 'jums taikomas nemokamas pristatymas', de: 'für Sie versandkostenfrei', da: 'du får gratis levering',
  fi: 'saat ilmaisen toimituksen', fr: 'livraison offerte pour vous', nl: 'je krijgt gratis verzending',
  no: 'du får gratis levering', sv: 'du får fri frakt', en: 'free delivery applies to your order'
};
const FREE_WITH = {
  lt: 'Pridėjus šią prekę, krepšelis pasieks %T ribą – pristatymas nemokamas',
  de: 'Mit diesem Artikel erreicht Ihre Bestellung %T – versandkostenfrei',
  da: 'Med denne vare når din ordre %T – gratis levering',
  fi: 'Tämän tuotteen kanssa tilauksesi saavuttaa %T – ilmainen toimitus',
  fr: 'Avec cet article, votre commande atteint %T – livraison offerte',
  nl: 'Met dit artikel bereikt je bestelling %T – gratis verzending',
  no: 'Med denne varen når bestillingen din %T – gratis levering',
  sv: 'Med den här varan når din beställning %T – fri frakt',
  en: 'Adding this item brings your order to %T or more – free delivery'
};
/* H1 (2026-10-05): a €199 dress showed "free over €200 (€1 to go)". When the second-colour offer is on the page and
   one more colour at −50 % would reach the threshold, the line says so instead. Threshold and prices are unchanged. */
const FREE_2C = {
  lt: 'nemokamas su antra spalva −25 %', de: 'kostenlos mit 2. Farbe −25 %', da: 'gratis med 2. farve −25 %',
  fi: 'ilmainen 2. värin kanssa (−25 %)', fr: 'offerte avec une 2e couleur à −25 %', nl: 'gratis met een 2e kleur −25%',
  no: 'gratis med 2. farge −25 %', sv: 'fri frakt med 2:a färgen −25 %', en: 'free with a 2nd colour at −25%'
};
const shipNear2c = (left, price) => left > 0 && left <= Math.ceil((Number(price) || 0) * 0.75) && !!main.querySelector('[data-d15]');
const shipMoney = (cents) => {
  const format = ((window.themeVariables || {}).settings || {}).moneyFormat || '€{{amount_with_comma_separator}}';
  const [int, dec] = (cents / 100).toFixed(2).split('.');
  const group = (sep) => int.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  const tail = (text, sep) => (dec === '00' ? text : text + sep + dec);
  return format.replace(/<[^>]*>/g, '').replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
    switch (key) {
      case 'amount_no_decimals': return group(',');
      case 'amount_with_comma_separator': return tail(group('.'), ',');
      case 'amount_no_decimals_with_comma_separator': return group('.');
      case 'amount_with_apostrophe_separator': return tail(group("'"), '.');
      case 'amount_with_space_separator': return tail(group(' '), ',');
      default: return tail(group(','), '.');
    }
  });
};
const shipVariant = () => {
  try { const v = JSON.parse(main.querySelector('variant-picker script[data-variant]').textContent); return { id: v.id, price: v.price }; } catch (error) { return null; }
};
const shipState = () => {
  const s = config && config.ship;
  if (!s || !(s.thr > 0)) return null;
  if (typeof s.cart !== 'number') return { left: s.left, text: s.left > 0 ? L.freeFrom.replace('%T', s.thrText).replace('%R', s.leftText) : L.free };
  if (s.cart >= s.thr) return { left: 0, text: FREE_YOU[config.lang] || FREE_YOU.en };
  const v = shipVariant() || { id: s.variant, price: s.price };
  const inCart = (s.ids || []).includes(Number(v.id));
  const left = s.thr - s.cart - (inCart ? 0 : Number(v.price) || 0);
  return { left, text: left > 0 ? L.freeFrom.replace('%T', s.thrText).replace('%R', shipMoney(left)) : (FREE_WITH[config.lang] || FREE_WITH.en).replace('%T', s.thrText) };
};
const shipCart = (cart) => {
  if (!config || !config.ship || !cart || typeof cart.total_price !== 'number') return;
  config.ship.cart = cart.total_price;
  config.ship.ids = (cart.items || []).map((item) => item.variant_id);
};
/* D15 prints its German texts with "du"; the store speaks "Sie" in German (DEV-286), so the states this file shows are given here */
if (config && config.lang === 'de') Object.assign(L, { soNosize: 'Wählen Sie zuerst Ihre Größe', soNocolour: 'Wählen Sie eine zweite Farbe', soNosize2: 'Wählen Sie eine Größe für die zweite Farbe', soError: 'Beide Kleider konnten nicht hinzugefügt werden. Der Warenkorb wurde nicht geändert. Bitte versuchen Sie es erneut.' });
const clean = (el) => (el ? el.textContent.replace(/\s+/g, ' ').trim() : '');
/* v11: prices without zero cents, as money_without_trailing_zeros prints them on the product cards ("€139,00" → "€139",
   "$162.00" → "$162", "€139,50" stays). Only a two-digit ",00"/".00" that ends a number is dropped, so thousands groups
   ("€1.000", "$1,000") and the shop's money format are kept. The theme's price-list (main price, compare-at price,
   shelves, feed) is re-rendered on variant change, so this runs from a MutationObserver before the next paint.
   D15 and the price breakdown keep their own formatting; the cart (outside <main>) is not touched. */
const trimCents = (text) => text.replace(/(\d)[.,]00(?!\d)/g, '$1');
const trimPrices = (root) => {
  root.querySelectorAll('price-list').forEach((list) => {
    if (list.closest('[data-block-id="d15_second_colour"], [data-block-id="liquid_transparent_pricing"]')) return;
    const walker = document.createTreeWalker(list, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const next = trimCents(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
  });
};
const priceText = () => {
  const price = main.querySelector('[data-block-type="price"] sale-price');
  if (!price) return '';
  const copy = price.cloneNode(true);
  copy.querySelectorAll('.sr-only').forEach((node) => node.remove());
  return trimCents(clean(copy));
};
const sizePicked = () => {
  const picker = main.querySelector('variant-picker[data-size-position]');
  if (!picker) return null;
  const position = picker.getAttribute('data-size-position');
  const input = picker.querySelector(`input[data-option-position="${position}"]:checked`);
  if (!input) return '';
  const label = picker.querySelector(`label[for="${CSS.escape(input.id)}"]`);
  return clean(label) || input.value;
};

/* model name + subtitle ("STORY – Linen Blend …" → STORY / Linen Blend …) */
const title = () => {
  const h1 = main.querySelector('.product-info__title');
  if (!h1 || h1.querySelector('.lm-sub')) return;
  const text = clean(h1);
  const match = text.match(/^(.+?)\s+[–—-]\s+(.+)$/);
  if (!match) return;
  h1.textContent = match[1];
  const sub = document.createElement('span');
  sub.className = 'lm-sub';
  sub.textContent = match[2];
  h1.append(sub);
};

/* ★★★★★ at the right of the price, only where the DEV-06 guard shows reviews */
const stars = () => {
  const row = main.querySelector('.product-info__price');
  if (!row || !config || !config.rating || row.querySelector('.lm-stars')) return;
  if (!document.getElementById('judgeme_product_reviews')) return; /* only where DEV-06 shows the widget */
  const link = document.createElement('a');
  link.className = 'lm-stars';
  link.href = '#judgeme_product_reviews';
  const avg = Math.round(config.rating.avg * 10) / 10;
  link.textContent = '★★★★★ ' + String(avg).replace('.', config.lang === 'en' ? '.' : ',') + ' (' + config.rating.n + ')';
  link.addEventListener('click', () => { const acc = document.querySelector('.lm-acc__reviews'); if (acc) acc.open = true; });
  row.append(link);
};

/* "Colour: Dusty rose · 17 colours" and the size-help link text */
const labels = () => {
  const picker = main.querySelector('variant-picker');
  if (!picker) return;
  picker.querySelectorAll('fieldset.variant-picker__option').forEach((fieldset) => {
    const swatches = fieldset.querySelectorAll('.color-swatch');
    const stack = fieldset.querySelector('.variant-picker__option-info .h-stack');
    if (swatches.length > 1 && stack && !stack.querySelector('.lm-ccount')) {
      const count = document.createElement('span');
      count.className = 'lm-ccount';
      count.textContent = '· ' + L.colours(swatches.length);
      stack.append(count);
    }
    /* v11 "Size: choose" while no size is picked (the size guard writes "Choose your size" there) */
    const sizePos = picker.getAttribute('data-size-position');
    const sizeInputs = sizePos ? [...fieldset.querySelectorAll(`input[data-option-position="${sizePos}"]`)] : [];
    if (sizeInputs.length) {
      const value = fieldset.querySelector('.variant-picker__option-info .h-stack > span:not(.lm-ccount)');
      const names = sizeInputs.map((input) => (input.nextElementSibling && input.nextElementSibling.textContent.trim()) || input.value);
      const fix = () => { if (value.textContent !== L.pick && !names.includes(value.textContent.trim())) value.textContent = L.pick; };
      if (value) {
        fix();
        /* the size guard rewrites the label on scroll/re-render; answer it at once so the text never flickers */
        if (!value.lmPickObs) { value.lmPickObs = new MutationObserver(fix); value.lmPickObs.observe(value, { childList: true, characterData: true, subtree: true }); }
      }
    }
    const help = fieldset.querySelector('.variant-picker__option-info > button .link');
    if (help && help.textContent.trim() !== L.help) help.textContent = L.help;
  });
};

/* "Add to cart · €139" on the main button and "Add to cart" in the sticky bar. The label is drawn from an attribute
   (CSS ::after), so the size guard, D8 and the theme keep writing their own text underneath; other states
   (sold out, pre-order, busy) are shown as they are.
   DEV-467: text drawn by ::after is not an accessible name (Lighthouse button-name), so the same label is also set as
   aria-label, in both states (size guard and size picked); it is removed with the attribute, and only if set here.
   DEV-477: while no size is picked (size guard) the button says "Select a size" instead of "Add to cart", on the main
   button and in the sticky bar; a tap still scrolls to the sizes (DEV-398). With a size it is "Add to cart · €price". */
const SIZE_FIRST = { en: 'Choose size', lt: 'Pasirink dydį', de: 'Größe wählen', fr: 'Choisir une taille', nl: 'Kies een maat', fi: 'Valitse koko', da: 'Vælg størrelse', no: 'Velg størrelse', sv: 'Välj storlek' };
const atcLabel = () => {
  const guard = /size|dyd|größe|taille|maat|storlek|størrelse|koko/i;
  const plain = (button) => {
    const original = button.getAttribute('data-lemuse-original-html');
    const text = clean(button.querySelector(':scope > div') || button) || '';
    return { text, original: original ? original.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim() : '' };
  };
  const drop = (button) => {
    button.removeAttribute('data-lm-label');
    if (button.hasAttribute('data-lm-aria')) { button.removeAttribute('aria-label'); button.removeAttribute('data-lm-aria'); }
  };
  const decide = (button, withPrice) => {
    if (button.getAttribute('aria-busy') === 'true') { drop(button); return; }
    const { text, original } = plain(button);
    const isAdd = original ? text === original : /add to cart|krepš|warenkorb|kurv|ostoskori|panier|winkelwagen|handlekurv|varukorg/i.test(text);
    const isGuard = button.hasAttribute('data-lemuse-explicit-size-guard') && guard.test(text);
    if (!isAdd && !isGuard) { drop(button); return; }
    const label = isGuard && !isAdd && !window.matchMedia('(max-width: 699px)').matches ? SIZE_FIRST[(config && config.lang) || 'en'] || SIZE_FIRST.en : withPrice && priceText() ? L.atc + ' · ' + priceText() : L.atc;
    if (button.getAttribute('data-lm-label') !== label) button.setAttribute('data-lm-label', label);
    if (button.getAttribute('aria-label') !== label && (button.hasAttribute('data-lm-aria') || !button.hasAttribute('aria-label'))) {
      button.setAttribute('aria-label', label);
      button.setAttribute('data-lm-aria', '');
    }
  };
  main.querySelectorAll('[data-block-type="buy-buttons"] buy-buttons > button[type="submit"]').forEach((button) => decide(button, true));
  document.querySelectorAll('product-quick-add button[type="submit"]').forEach((button) => decide(button, false));
};

/* one trust box: delivery estimate + free shipping, the market's tax line (D2), returns */
const trust = () => {
  const info = main.querySelector('.product-info');
  if (!info) return;
  let box = info.querySelector(':scope > .lm-tline');
  if (!box) {
    box = document.createElement('div');
    box.className = 'lm-tline';
    info.append(box);
  }
  /* DEV-458 (Developeris F, 2026-09-29): delivery (price for the chosen country, arrival dates) right under Add to cart,
     before the D15 second colour offer and the price breakdown; the returns line (tryAtHome) follows it */
  const buy = info.querySelector(':scope > [data-block-type="buy-buttons"]');
  if (buy) {
    if (box.style.order !== '7') box.style.order = '7';
    /* G-1013-09 (2026-10-13): snippets/cro08-lead-time (UI-07) keeps its delivery-date line ([data-ui07-surface]) right above
       this box, i.e. between Add to cart and the box. Moving the box back above that line made UI-07 move its line again, and
       the two kept swapping places about 12 times a second for as long as the page was open. The line in between is allowed. */
    /* CRO-57b v3 (Developeris G, 2026-10-16): snippets/cro08-lead-time (CRO-49) puts its short delivery line (.lm-eta), and the
       faster-variant copy after it (.lm-fast--eta), right under Add to cart when the button ends below the first screen. Moving
       the box back above them made CRO-08 move its line again, ~4 times a second for as long as the page was open (MILDA,
       phone: Add to cart block jumping, CLS 1.2). Those lines between Add to cart and the box are allowed too. */
    let prev = box.previousElementSibling;
    while (prev && prev !== buy && prev.matches('[data-ui07-surface], .lm-eta, .lm-fast--eta')) prev = prev.previousElementSibling;
    if (prev !== buy) buy.after(box);
  }
  /* v11 .tline, word for word: delivery time (+ free-shipping threshold in the shop currency), DDP, returns; plain ✓ lines, no links */
  let ship = '';
  const shipNow = shipState();
  if (shipNow) ship = shipNow.text;
  /* DEV-270: returns moved out of this box to the "try it on at home" line right under Add to cart (tryAtHome) */
  /* DEV-388: one dispatch promise on the page. The delivery line is the selected variant's CRO-08 lead time
     (snippets/cro08-lead-time: in stock "ships in 2 business days" or made to order "ships within 14 days",
     with the visitor's zone dates, already in the store's 9 languages); its own block stays hidden.
     A sold-out variant has no CRO-08 line, so the general "2–5 business days" stays. */
  const c8 = main.querySelector('[data-cro08]');
  /* the CRO-08 texts end in a full stop; drop it after a word or a day number, keep it on abbreviations ("14 d.", "Okt.") */
  const c8Head = c8 ? clean(c8.querySelector('[data-cro08-head]')).replace(/(\p{L}{4,})\.$/u, '$1') : '';
  const c8Date = c8 ? clean(c8.querySelector('[data-cro08-date]')).replace(/(\d)\.$/, '$1') : '';
  /* DEV-458: the delivery price for the chosen country (config.fee, the cart's wording) gets its own line with the
     free-shipping remainder; without a known price the remainder stays on the first line as before */
  const fee = config && config.fee ? String(config.fee).replace(/\.$/, '') : '';
  const feeLine = fee ? { text: [fee, shipNow && (shipNow.left > 0 || typeof config.ship.cart === 'number') ? ship : ''].filter(Boolean).join(' · ') } : null;
  const headShip = fee ? '' : ship;
  /* DEV-470 (2026-09-29): "No customs fees in the EU; prices include VAT" is only true for the 27 EU countries (DDP and
     VAT-inclusive prices apply there); visitors from elsewhere (US, GB, CH, NO…) get no line instead of a wrong one.
     DEV-472 (2026-09-29): import duties are paid by us for every country (DDP), so visitors from outside the EU get the
     same promise as /pages/delivery ("included: we pay them") instead of no line. */
  const EU = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];
  /* DEV-549 (Developeris B, 2026-09-29): the duties line sits in a white card and got dead clicks (Clarity); it now links to
     /pages/delivery (duties and taxes explained in the store's 9 languages), underlined so it reads as a link */
  const ddpHref = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/delivery';
  const ddp = !(window.Shopify && Shopify.country) || EU.includes(Shopify.country) ? [{ text: L.ddp, href: ddpHref }] : [{ text: L.ddpWorld, href: ddpHref }];
  const lines = c8Head
    ? [{ text: [c8Head, headShip].filter(Boolean).join(' · ') }, c8Date ? { text: c8Date } : null, feeLine, ...ddp].filter(Boolean)
    : [{ text: [L.ship, headShip].filter(Boolean).join(' · ') }, feeLine, ...ddp].filter(Boolean);
  const html = lines.map((line) => '<span>✓ ' + (line.href ? '<a></a>' : '') + '</span>').join('');
  if (box.dataset.lmSig === JSON.stringify(lines)) return;
  box.dataset.lmSig = JSON.stringify(lines);
  box.innerHTML = html;
  [...box.children].forEach((span, index) => {
    const line = lines[index];
    if (line.href) { const a = span.querySelector('a'); a.href = line.href; a.textContent = line.text; a.style.cssText = 'text-decoration:underline;text-underline-offset:2px;'; }
    else span.append(line.text);
  });
};

/* DEV-270 (Developeris D, 2026-09-27): returns line right under Add to cart, with the refund policy link of the
   visitor's language. Replaces the returns line of the trust box, so 30 days is said once.
   DEV-458 (Developeris F, 2026-09-29): it now sits under the delivery box and says the cart's words
   (cart.general.returns_note_html in the theme's 9 locales): 30 days, eligible items, we cover standard return shipping. */
const TAH = {
  lt: ['30 dienų grąžinimas tinkamoms prekėms · standartinio grąžinimo siuntos išlaidas padengiame mes.', 'Plačiau'],
  de: ['30 Tage Rückgaberecht für berechtigte Artikel · den Standardversand der Rücksendung übernehmen wir.', 'Details'],
  da: ['30 dages returret på kvalificerede varer · vi betaler standardfragten ved returnering.', 'Læs mere'],
  fi: ['30 päivän palautusoikeus kelpoisiin tuotteisiin · maksamme tavallisen palautuslähetyksen.', 'Lisätietoja'],
  fr: ['Retours sous 30 jours sur les articles éligibles · nous prenons en charge les frais de retour standard.', 'En savoir plus'],
  nl: ['30 dagen retourrecht op in aanmerking komende artikelen · wij betalen de standaard retourzending.', 'Meer informatie'],
  no: ['30 dagers returrett på kvalifiserte varer · vi dekker standard returfrakt.', 'Les mer'],
  sv: ['30 dagars returrätt på berättigade varor · vi betalar standardfrakten för returen.', 'Läs mer'],
  en: ['30-day returns on eligible items · we cover standard return shipping.', 'Details']
};
const tryAtHome = () => {
  const info = main.querySelector('.product-info');
  const buy = info && info.querySelector(':scope > [data-block-type="buy-buttons"]');
  if (!buy) return;
  let line = info.querySelector(':scope > .lm-tah');
  if (!line) {
    const [text, linkText] = TAH[(config && config.lang) || 'en'] || TAH.en;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    line = document.createElement('p');
    line.className = 'lm-tah';
    /* same flex order as Add to cart (7), placed after it in the DOM (DEV-458: after the delivery box): above the D15 box (8) */
    line.style.cssText = 'order:7;margin:0;font-size:14px;line-height:1.4;color:#2f6a4f;';
    const link = document.createElement('a');
    link.href = root + 'policies/refund-policy';
    link.textContent = linkText;
    link.style.cssText = 'color:inherit;text-decoration:underline;text-underline-offset:2px;';
    line.append(text + ' ', link);
  }
  const anchor = info.querySelector(':scope > .lm-tline') || buy;
  if (line.previousElementSibling !== anchor) anchor.after(line);
};

/* accordions under the product: Description, Fabric & care (+ fabric sample link), Size chart (+ model line), Reviews */
const details = (title, extraClass) => {
  const item = document.createElement('details');
  item.className = 'lm-acc__item ' + (extraClass || '');
  const summary = document.createElement('summary');
  summary.textContent = title;
  const body = document.createElement('div');
  body.className = 'lm-in';
  item.append(summary, body);
  return item;
};
const accordions = () => {
  const product = main.querySelector('.product');
  const info = main.querySelector('.product-info');
  if (!product || !info) return;
  let acc = main.querySelector('.lm-acc');
  if (!acc) {
    acc = document.createElement('div');
    acc.className = 'lm-acc';
    product.after(acc);
  }
  /* 1 description */
  const description = info.querySelector(':scope > [data-block-type="description"]');
  if (description) {
    let item = acc.querySelector('.lm-acc__desc');
    if (!item) { item = details(L.desc, 'lm-acc__desc'); acc.prepend(item); }
    item.querySelector('.lm-in').append(description);
  }
  /* 2 collapsible texts (Fabric & care …), shipping & returns is covered by the trust box and stays hidden */
  const sizeItem = acc.querySelector('.lm-acc__size');
  const reviewsItem = acc.querySelector('.lm-acc__reviews');
  info.querySelectorAll(':scope > .accordion-group, :scope > [data-block-type="collapsible-text"], :scope > .product-info__block-group:has([data-block-type="collapsible-text"])').forEach((group) => {
    const blocks = group.matches('[data-block-type="collapsible-text"]') ? [group] : [...group.querySelectorAll('[data-block-type="collapsible-text"]')];
    blocks.forEach((block) => {
      if (block.getAttribute('data-block-id') === 'collapsible_text_baQ3hA') return;
      acc.insertBefore(block, sizeItem || reviewsItem || null);
    });
  });
  const sample = info.querySelector(':scope > [data-block-id="cro17_sample_help"]');
  const fabric = acc.querySelector('[data-block-type="collapsible-text"] .accordion__content');
  if (sample && fabric) fabric.append(sample);
  /* DEV-635 (Developeris F, 2026-10-06): "Fabric & care" filled from empty metafields (the Nida styles) opened empty; an
     accordion with no text and no picture is hidden until it has content again. */
  acc.querySelectorAll(':scope > [data-block-type="collapsible-text"]').forEach((block) => {
    const body = block.querySelector('.accordion__content');
    const empty = !!body && !body.textContent.trim() && !body.querySelector('img, video, iframe');
    block.style.display = empty ? 'none' : '';
  });
  /* 3 size chart: D6 measurements, with the model line */
  const d6 = info.querySelector(':scope > [data-block-id="d6_measurements"]');
  if (d6) {
    acc.insertBefore(d6, reviewsItem || null);
    d6.classList.add('lm-acc__size');
  }
  const d6Summary = acc.querySelector('[data-block-id="d6_measurements"] summary');
  if (d6Summary) {
    const toggle = d6Summary.querySelector('.accordion__toggle') || d6Summary;
    const target = toggle.querySelector('.text-with-icon') || toggle;
    if (clean(target) !== L.chart) target.textContent = L.chart;
  }
  const help = main.querySelector('.product-info .lm-size-help');
  const d6Content = acc.querySelector('[data-block-id="d6_measurements"] .accordion__content');
  if (help && d6Content) {
    const copy = d6Content.querySelector(':scope > .lm-size-help');
    /* DEV-430: D6 already prints "Fit: … Model is 175 cm …" in its body, so the same model height is not added twice */
    const height = (help.textContent.match(/\d+(?:[.,]\d+)?\s*cm/) || [])[0];
    const d6Line = d6Content.querySelector('.d6-body > p');
    if (height && d6Line && d6Line.textContent.includes(height)) {
      if (copy) copy.remove();
    } else if (!copy) d6Content.prepend(help.cloneNode(true));
    else if (copy.textContent !== help.textContent) copy.textContent = help.textContent;
  }
  /* D6 prints its "compare your measurements" line outside its own <details>; in v6 it sits inside the size chart */
  const d6Help = acc.querySelector('[data-block-id="d6_measurements"] .d6-help');
  if (d6Help && d6Content && !d6Content.contains(d6Help)) d6Content.append(d6Help);
  /* 4 reviews: the DEV-06 Judge.me widget, only when it is rendered */
  const widget = document.getElementById('judgeme_product_reviews');
  if (widget && !acc.querySelector('.lm-acc__reviews')) {
    const item = details(L.reviews + (config && config.rating ? ' (' + config.rating.n + ')' : ''), 'lm-acc__reviews');
    item.querySelector('.lm-in').append(widget);
    acc.append(item);
  }
  if (!acc.children.length) acc.remove();
};

/* shelves: "Similar styles" and "Pair it with" scroll sideways; the first one links to the whole category.
   Product recommendations are fetched after load and replace the section content, so this runs again on every change. */
const SHELVES = [['__related-products', 'similar', true], ['__related_products_yHmj9g', 'pair', false]];
const shelves = () => {
  SHELVES.forEach(([suffix, key, withAll]) => {
    const section = document.querySelector(`main > [id$="${suffix}"]`);
    if (!section) return;
    section.classList.add('lm-shelf');
    const heading = section.querySelector('section-header h2');
    if (heading && clean(heading) !== L[key]) heading.textContent = L[key];
    const track = section.querySelector('.product-list');
    if (track && !track.dataset.lmStart) { track.dataset.lmStart = '1'; track.scrollLeft = 0; }
    if (!withAll || !config || !config.cat || !config.cat.count) return;
    const header = section.querySelector('section-header');
    if (header && !header.querySelector('.lm-shelf__all')) {
      const all = document.createElement('a');
      all.className = 'lm-shelf__all';
      all.href = config.cat.url;
      all.textContent = L.all.replace('%N', config.cat.count);
      header.append(all);
    }
    const list = section.querySelector('.product-list');
    if (list && list.querySelector('product-card') && !list.querySelector('.lm-more-card')) {
      const card = document.createElement('a');
      card.className = 'lm-more-card';
      card.href = config.cat.url;
      card.textContent = L.allCard.replace('%N', config.cat.count);
      list.append(card);
    }
  });
};
const watchShelves = () => {
  SHELVES.forEach(([suffix]) => {
    const section = document.querySelector(`main > [id$="${suffix}"]`);
    if (!section) return;
    let timer = 0;
    new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(shelves, 50); }).observe(section, { childList: true, subtree: true });
  });
};

/* phone: back button over the photo */
const backButton = () => {
  const wrapper = main.querySelector('.product-gallery__media-list-wrapper');
  if (!wrapper || wrapper.querySelector('.lm-back')) return;
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'lm-back';
  button.setAttribute('aria-label', L.back);
  button.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 5l-7 7 7 7"/></svg>';
  button.addEventListener('click', () => {
    let internal = false;
    try { internal = document.referrer && new URL(document.referrer).origin === location.origin; } catch (error) {}
    if (internal && history.length > 1) history.back();
    else location.href = (config && config.cat && config.cat.url) || '/';
  });
  wrapper.append(button);
};

/* sticky bar: name, "price · size" */
const stickyMini = () => {
  const bar = document.querySelector('product-quick-add .product-quick-add__variant');
  if (!bar) return;
  let mini = bar.querySelector(':scope > .lm-mini');
  if (!mini) {
    mini = document.createElement('div');
    mini.className = 'lm-mini';
    mini.innerHTML = '<b></b><span></span>';
    bar.prepend(mini);
  }
  const h1 = main.querySelector('.product-info__title');
  const name = h1 ? clean(h1.firstChild && h1.firstChild.nodeType === 3 ? { textContent: h1.firstChild.textContent } : h1) : '';
  const size = sizePicked();
  const line = [priceText(), size === null ? '' : (size || L.sizeq)].filter(Boolean).join(' · ');
  if (mini.firstChild.textContent !== name) mini.firstChild.textContent = name;
  if (mini.lastChild.textContent !== line) mini.lastChild.textContent = line;
};

/* blocks that print nothing (styles or scripts only) take no gap in the column */
const empties = () => {
  main.querySelectorAll('.product-info > .product-info__block-item').forEach((block) => {
    const visible = [...block.querySelectorAll('*')].some((node) => !node.closest('style, script, template') && !/^(STYLE|SCRIPT|TEMPLATE|LINK|META)$/.test(node.tagName) && (node.children.length === 0 ? clean(node) || /^(IMG|SVG|INPUT|BUTTON|IFRAME|VIDEO)$/.test(node.tagName) : false));
    block.classList.toggle('lm-empty', !visible);
  });
};

/* desktop (same breakpoint as the two-column CSS): the accordions sit in the left column under the gallery, as a grid item
   of .product; below it they stay after .product as before. The same node is moved, nothing is copied. */
const DESK = window.matchMedia('screen and (min-width: 1000px)');
const placeAccordions = () => {
  const acc = main.querySelector('.lm-acc');
  const product = main.querySelector('.product');
  if (!acc || !product) return;
  if (DESK.matches) { if (acc.parentElement !== product) product.append(acc); }
  else if (acc.parentElement === product) product.after(acc);
};

/* DEV-474 (2026-09-29): L.soText now says what the automatic discount does (collection "second-colour", 75 styles): any two
   styles from the offer, the lower-priced one −50 %; another colour of this style stays the suggestion.
   D15 second colour −50 % as in v11: the design's text, the second colour already picked, no second size row (the second
   dress takes the size picked above; the row comes back only when that size is sold out in the second colour), and one
   strong button "Add both · €208.50 ~~€278~~". D15 keeps its own state, prices and cart request; this only sets its first
   colour once, when none is chosen, and draws the label and the hint while its button waits for a size. */
const D15_SAME = { lt: 'Antra spalva turi skirtis nuo pirmos', de: 'Die zweite Farbe muss sich von der ersten unterscheiden', da: 'Den anden farve skal være forskellig fra den første', fi: 'Toisen värin on oltava eri kuin ensimmäisen', fr: 'La seconde couleur doit être différente de la première', nl: 'De tweede kleur moet anders zijn dan de eerste', no: 'Den andre fargen må være forskjellig fra den første', sv: 'Den andra färgen måste skilja sig från den första', en: 'The second colour must differ from the first' };
const d15 = () => {
  const root = main.querySelector('[data-d15]');
  if (!root) return;
  const text = root.querySelector('.d15-text');
  if (text && text.textContent !== L.soText) text.textContent = L.soText;
  const swatches = root.querySelector('[data-d15-swatches]');
  const others = swatches ? swatches.querySelectorAll('.d15-swatch:not(.lm-d15-cur)') : [];
  /* DEV-404: no second colour is picked for the shopper any more; "Add to cart" stays the one main action.
     Only the "−50 %" in the title stays red (.lm-d15-off), the rest of the box is neutral. */
  const title = root.querySelector('.d15-title');
  if (title && !title.querySelector('.lm-d15-off')) {
    const words = title.textContent.match(/^(.*?)([−-]\s?\d+\s?%)(.*)$/);
    if (words) {
      const off = document.createElement('span');
      off.className = 'lm-d15-off';
      off.textContent = words[2];
      title.replaceChildren(words[1], off, words[3]);
    }
  }
  /* v11: the row starts with the colour already chosen above; it can't be the second one */
  const mainSwatch = main.querySelector('.variant-picker__option-values :checked + .color-swatch');
  if (others.length && mainSwatch) {
    const shown = mainSwatch.closest('fieldset') && mainSwatch.closest('fieldset').querySelector('.variant-picker__option-info .h-stack > span:not(.lm-ccount)');
    const name = (shown && shown.textContent.trim()) || root.dataset.mainColour || '';
    let cur = swatches.querySelector('.lm-d15-cur');
    if (!cur) {
      cur = document.createElement('button');
      cur.type = 'button';
      cur.className = 'd15-swatch lm-d15-cur';
      cur.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const error = root.querySelector('[data-d15-error]');
        if (!error) return;
        error.textContent = D15_SAME[(config && config.lang) || 'en'] || D15_SAME.en;
        error.hidden = false;
        clearTimeout(cur.lmTimer);
        cur.lmTimer = setTimeout(() => { error.hidden = true; }, 3000);
      });
    }
    if (cur.dataset.lmColour !== name) {
      const look = getComputedStyle(mainSwatch);
      cur.style.background = look.backgroundImage !== 'none' ? look.backgroundImage + ' center / cover, ' + look.backgroundColor : look.backgroundColor;
      cur.dataset.lmColour = name;
      cur.setAttribute('aria-label', name);
      cur.title = name;
    }
    if (swatches.firstElementChild !== cur) swatches.prepend(cur);
  }
  const add = root.querySelector('[data-d15-add]');
  const own = root.querySelector('[data-d15-add-label]');
  if (!add || !own) return;
  const state = own.textContent.trim();
  const ds = root.dataset;
  const noSize = state === ds.lNosize;
  const needSize2 = state === ds.lNosize2;
  root.classList.toggle('lm-d15-need2', needSize2);
  root.classList.toggle('lm-d15-nosize', noSize);
  let label = add.querySelector('.lm-d15-l');
  if (!label) {
    label = document.createElement('span');
    label.className = 'lm-d15-l';
    add.append(label);
  }
  const addText = own.getAttribute('data-add-text') || '';
  const total = addText.includes(' · ') ? addText.slice(addText.lastIndexOf(' · ') + 3) : '';
  let html;
  if (state === addText || noSize) html = L.both + (total ? ' · ' + total : '') + (config && config.soOld ? ' <s></s>' : '');
  else if (needSize2 && L.soNosize2) html = '';
  else if (state === ds.lNocolour && L.soNocolour) html = '';
  else html = null;
  const sig = JSON.stringify([state, html]);
  if (label.dataset.sig === sig) return;
  label.dataset.sig = sig;
  if (html === null) { label.hidden = true; add.classList.remove('lm-d15-own'); return; }
  label.hidden = false;
  add.classList.add('lm-d15-own');
  if (html === '') { label.textContent = needSize2 ? L.soNosize2 : L.soNocolour; return; }
  label.innerHTML = html;
  label.firstChild.textContent = L.both + (total ? ' · ' + total + ' ' : '');
  const old = label.querySelector('s');
  if (old) old.textContent = config.soOld;
};
/* the D15 button waits for the size above; in v11 it looks ready and a tap asks for the size */
const d15Hint = () => {
  const root = main.querySelector('[data-d15]');
  if (!root || root.__lmHint) return;
  root.__lmHint = true;
  root.addEventListener('click', (event) => {
    if (!root.classList.contains('lm-d15-nosize')) return;
    const add = root.querySelector('[data-d15-add]');
    if (!add || !add.disabled) return;
    const box = add.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) return;
    const error = root.querySelector('[data-d15-error]');
    if (error) { error.textContent = L.soNosize || root.dataset.lNosize; error.hidden = false; setTimeout(() => { error.hidden = true; }, 3000); }
    const picker = main.querySelector('variant-picker[data-size-position]');
    const input = picker && picker.querySelector(`input[data-option-position="${picker.getAttribute('data-size-position')}"]`);
    const fieldset = input && input.closest('fieldset');
    if (fieldset) fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  /* the German error line is D15's own text with "du" */
  if (L.soError) {
    const error = root.querySelector('[data-d15-error]');
    if (error) new MutationObserver(() => { if (!error.hidden && error.textContent === root.dataset.lError) error.textContent = L.soError; }).observe(error, { attributes: true, childList: true, characterData: true, subtree: true });
  }
};

/* D15 prints the colour values as Shopify outputs linked colours: in English in every language (DEV-50), so LT read
   "Antra spalva: Red". The main picker already shows the translated names (snippets/colour-name.liquid). They are matched
   by value, not by position (the main picker may hide sold-out colours, and D15's row is reordered): each main swatch input
   names its variant (data-variant-id), and D15's own variant list gives that variant's English colour. The D15 colour name,
   swatch labels and tooltips take the translated name; D15 keeps matching on its own English values, and a
   MutationObserver answers each D15 re-render at once. */
const d15Names = () => {
  const root = main.querySelector('[data-d15]');
  if (!root || root.__lmNames) return;
  const json = [...root.querySelectorAll('script')].find((node) => node.textContent.trim().startsWith('{"sizes"'));
  let data = null;
  try { data = JSON.parse(json.textContent); } catch (error) { return; }
  const position = root.dataset.colourPos;
  if (!data || !Array.isArray(data.colours) || !position) return;
  root.__lmNames = true;
  const english = colourNames.english;
  (data.variants || []).forEach((variant) => { english[variant.id] = variant.c; });
  const map = colourNames.map;
  const learn = colourNames.learn = () => {
    const picker = main.querySelector('variant-picker');
    if (!picker) return;
    const inputs = [...picker.querySelectorAll(`input[data-option-position="${position}"]`)];
    const shown = inputs.map((input) => clean(picker.querySelector(`label[for="${CSS.escape(input.id)}"]`)));
    inputs.forEach((input, index) => {
      /* by value; by position only when the picker gives no variant ids and lists every colour D15 has */
      const name = english[input.dataset.variantId] || (!input.dataset.variantId && inputs.length === data.colours.length ? data.colours[index].n : '');
      if (name && shown[index] && name !== shown[index]) map[name] = shown[index];
    });
  };
  const fix = () => {
    learn();
    const name = root.querySelector('[data-d15-colour-name]');
    if (name && map[name.textContent]) name.textContent = map[name.textContent];
    root.querySelectorAll('[data-d15-swatches] [data-colour]').forEach((button) => {
      const label = map[button.dataset.colour];
      if (label && button.title !== label) { button.title = label; button.setAttribute('aria-label', label); }
    });
  };
  new MutationObserver(fix).observe(root, { childList: true, subtree: true, characterData: true });
  fix();
};

/* D14 ("Liko tik 2 vnt. dydžio XS, spalva Deep blue") prints the variant's colour the same way, in English. It takes the
   translated name from the same source as D15 above: D15's variant list (variant id → English colour) and the main
   picker's labels (English → translated). Only the colour value of the variant D14 names is replaced; the theme
   re-renders the block on variant change and apply() runs again. Without D15 on the page the text stays as printed. */
const colourNames = { english: {}, map: {}, learn: null };
const d14Names = () => {
  const note = main.querySelector('.d14-stock[data-d14-variant]');
  const span = note && note.querySelector('span');
  if (!span || span.textContent === span.dataset.lmDone) return;
  if (colourNames.learn) {
    colourNames.learn();
    const en = colourNames.english[note.dataset.d14Variant];
    const local = en && colourNames.map[en];
    const text = span.textContent;
    const at = en ? text.lastIndexOf(' ' + en) : -1;
    if (local && at >= 0) {
      span.textContent = text.slice(0, at + 1) + local + text.slice(at + 1 + en.length);
      span.dataset.lmDone = span.textContent;
      return;
    }
  }
  d14Picker(note, span);
};

/* DEV-438 (2026-09-27): without D15 on the page (or when D15 cannot name the variant) D14 still said "Farbe Deep blue"
   while the picker says "Dunkelblau". D14 always names the selected variant, so when the product has one option besides
   size, its checked picker label is the translated value: the text after D14's own colour word is replaced with it. */
const d14Picker = (note, span) => {
  const picker = main.querySelector('variant-picker[form-id^="product-form"]') || main.querySelector('variant-picker');
  const form = picker && document.getElementById(picker.getAttribute('form-id'));
  /* the id input is disabled until a size is picked, but it still names the variant shown */
  const id = form && form.querySelector('input[name="id"]');
  if (!id || id.value !== note.dataset.d14Variant) return;
  const size = picker.getAttribute('data-size-position');
  const positions = [...new Set([...picker.querySelectorAll('input[data-option-position]')].map((input) => input.dataset.optionPosition))].filter((position) => position !== size);
  if (positions.length !== 1) return;
  const checked = picker.querySelector(`input[data-option-position="${positions[0]}"]:checked`);
  const label = checked && clean(picker.querySelector(`label[for="${CSS.escape(checked.id)}"]`));
  const match = span.textContent.match(/^(.*, (?:colou?r|spalva|Farbe|couleur|farve|väri|kleur|farge|färg) )(.+)$/i);
  if (!label || !match || match[2] === label) return;
  span.textContent = match[1] + label;
  span.dataset.lmDone = span.textContent;
};

let busy = false;
const apply = () => {
  if (busy) return;
  busy = true;
  try {
    title(); stars(); labels(); atcLabel(); d15Names(); d14Names(); d15(); trust(); tryAtHome(); accordions(); placeAccordions(); backButton(); stickyMini(); empties();
  } catch (error) { console.warn('[lm-pdp]', error); }
  busy = false;
};

if (main) {
  const page = document.querySelector('main') || document.body;
  trimPrices(page);
  new MutationObserver(() => trimPrices(page)).observe(page, { childList: true, subtree: true, characterData: true });
  apply();
  if (DESK.addEventListener) DESK.addEventListener('change', placeAccordions); else if (DESK.addListener) DESK.addListener(placeAccordions);
  shelves();
  watchShelves();
  ['variant:change', 'product:rerender', 'change'].forEach((name) => document.addEventListener(name, () => requestAnimationFrame(apply), true));
  /* DEV-492: re-read the cart after every change (the theme's cart:change / cart:refresh), then redraw the trust box */
  const shipRefresh = (event) => {
    const cart = event && event.detail && event.detail.cart;
    if (cart && typeof cart.total_price === 'number') { shipCart(cart); requestAnimationFrame(apply); return; }
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => { shipCart(c); requestAnimationFrame(apply); }).catch(() => {});
  };
  if (config && config.ship) ['cart:change', 'cart:refresh'].forEach((name) => document.addEventListener(name, shipRefresh));
  let applyTimer = 0;
  /* PDP ♡: the theme re-renders buy-buttons on size/colour change, so put the heart back after every re-render */
  new MutationObserver(() => { heart(); if (busy) return; clearTimeout(applyTimer); applyTimer = setTimeout(apply, 60); }).observe(main, { childList: true, subtree: true, characterData: true });
  setInterval(() => { atcLabel(); stickyMini(); d15(); }, 500);
  d15Hint();
  heart();
  gridZoom();
  studioLink();
  geoBar();
  counter();
  presetSize();
  featuredFirst(document);
  new MutationObserver(() => featuredFirst(document)).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  moreFromCategory();
}

/* DEV-398 (2026-09-27): without a size the main "Add to cart" is disabled, so a tap did nothing. The disabled button now
   lets the tap through to its container (like the sticky bar does), and the tap scrolls to the sizes, flashes them and
   says "Please select a size" under them. Nothing is added to the cart. */
(() => {
  const TEXT = { en: 'Please select a size', lt: 'Pasirink dydį', de: 'Bitte wählen Sie eine Größe', fr: 'Veuillez choisir une taille', nl: 'Kies een maat', fi: 'Valitse koko', da: 'Vælg en størrelse', no: 'Velg en størrelse', sv: 'Välj en storlek' };
  const lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  const style = document.createElement('style');
  style.textContent = '.shopify-section--main-product .product-info__buy-buttons button[disabled][data-lemuse-explicit-size-guard]{pointer-events:none}'
    + '.shopify-section--main-product .product-info__buy-buttons{cursor:pointer}'
    + '.lm-size-msg{margin:8px 0 0;font-size:var(--text-sm);font-weight:600;color:rgb(var(--error-text,196 30 58))}'
    + '.lm-size-flash{animation:lmSizeFlash 1.2s ease;border-radius:var(--rounded-sm)}'
    + '@keyframes lmSizeFlash{20%{box-shadow:0 0 0 3px rgb(var(--text-color) / .45)}100%{box-shadow:0 0 0 0 transparent}}';
  document.head.appendChild(style);
  const sizeFieldset = (vp) => {
    const pos = vp.getAttribute('data-size-position');
    if (!pos || pos === '0') return null;
    const input = vp.querySelector('input[data-option-position="' + pos + '"]');
    return input ? input.closest('fieldset') : null;
  };
  document.addEventListener('click', (event) => {
    const box = event.target.closest && event.target.closest('.shopify-section--main-product .product-info__buy-buttons');
    if (!box || event.target.closest('a')) return;
    const button = box.querySelector('button[type="submit"][data-lemuse-explicit-size-guard]');
    /* form.id would return the form's hidden input named "id", so the id is read as an attribute */
    const form = box.querySelector('form[id]') || (button && button.form);
    if (!button || !form) return;
    const vp = document.querySelector('variant-picker[form-id="' + form.getAttribute('id') + '"]');
    const fs = vp && sizeFieldset(vp);
    if (!fs || fs.querySelector('input[data-option-position]:checked')) return;
    event.preventDefault();
    let msg = fs.querySelector('.lm-size-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'lm-size-msg';
      msg.setAttribute('role', 'alert');
      fs.appendChild(msg);
    }
    msg.textContent = TEXT[lang] || TEXT.en;
    fs.scrollIntoView({ block: 'center', behavior: 'smooth' });
    fs.classList.remove('lm-size-flash');
    void fs.offsetWidth;
    fs.classList.add('lm-size-flash');
    setTimeout(() => fs.classList.remove('lm-size-flash'), 1300);
    const first = fs.querySelector('input[data-option-position]');
    if (first) { try { first.focus({ preventScroll: true }); } catch (error) {} }
  }, true);
  document.addEventListener('change', (event) => {
    const fs = event.target.closest && event.target.closest('fieldset');
    const msg = fs && fs.querySelector('.lm-size-msg');
    if (msg) msg.remove();
  }, true);
})();

/* DEV-427 (2026-09-27): labels that stayed in English or were wrong in other languages. The size chart comes from the
   page "size-chart-v2" and the breadcrumbs from a Custom Liquid section, so neither can use the locale files:
   screen readers heard "Measurement units" and "Breadcrumb" in every language, and the French unit switch read "POUCE". */
(() => {
  const lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  const UNITS = { lt: 'Matavimo vienetai', de: 'Maßeinheiten', fr: 'Unités de mesure', nl: 'Maateenheden', fi: 'Mittayksiköt', da: 'Måleenheder', no: 'Måleenheter', nb: 'Måleenheter', sv: 'Måttenheter' };
  const CRUMB = { lt: 'Naršymo kelias', de: 'Brotkrümelnavigation', fr: 'Fil d’Ariane', nl: 'Kruimelpad', fi: 'Murupolku', da: 'Brødkrummesti', no: 'Brødsmulesti', nb: 'Brødsmulesti', sv: 'Brödsmulor' };
  if (!UNITS[lang]) return;
  document.querySelectorAll('.lm-sg .lm-tg[aria-label="Measurement units"]').forEach((el) => el.setAttribute('aria-label', UNITS[lang]));
  document.querySelectorAll('nav.d9-breadcrumbs[aria-label="Breadcrumb"]').forEach((el) => el.setAttribute('aria-label', CRUMB[lang]));
  if (lang === 'fr') {
    document.querySelectorAll('.lm-sg label[for="lm-sc-in"]').forEach((el) => { if (el.textContent.trim() === 'POUCE') el.textContent = 'POUCES'; });
  }
})();


